<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <user-show :id="id" @gotAttrs="assignAttrs"></user-show>
    <profile-index
      :filtering="filtering"
      :ams_template="ams_template"
    ></profile-index>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import UserShow from './UserShow.vue'
import ProfileIndex from './ProfileIndex.vue'

export default {
  components: {
    VuexBreadcrumb,
    UserShow,
    ProfileIndex,
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        user_ids: this.id
      },
      ams_template: {
        type: 'profiles',
        description: undefined,
        attributes: {
          'user-id': this.id,
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + ' ' + this.attrs['name'] + ' ' + this.attrs['email']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>